export default __webpack_public_path__ + "images/models/9732438bbf8c678b5b85c3656aa360dc.glb";